import React, { FC, useEffect, useState } from 'react';
import { SCUIGeneralModal, SCUITextFieldWithSelectBox } from '../../../../../atomic/molecules';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { SCUILoadingLinear } from '../../../../../atomic/atoms';

export const SCUICreateReturnModal: FC<{
    open: boolean;
    onClose: any;
    searchedOrderNotFound?: any;
}> = ({ open, onClose, searchedOrderNotFound }) => {
    const history = useHistory();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [searchedText, setSearchedText] = useState('');
    const [documentType, setDocumentType] = useState(1);

    useEffect(() => {
        if (searchedOrderNotFound) {
            if (searchedOrderNotFound.OrderNumber) {
                history.push(`/createReturn?orderNumber=` + searchedOrderNotFound.OrderNumber);
            }
            if (searchedOrderNotFound.ShippingListNo) {
                history.push(`/createReturn?shippingListNo=` + searchedOrderNotFound.ShippingListNo);
            }
        }
    }, [searchedOrderNotFound]);

    const listele = async () => {
        setLoading(true);
        let path =
            documentType === 1
                ? `/createReturn?orderNumber=` + searchedText
                : `/createReturn?shippingListNo=` + searchedText;
        history.push(path);
    };

    return (
        <React.Fragment>
            {!searchedOrderNotFound && (
                <SCUIGeneralModal
                    open={open}
                    onClose={onClose}
                    width={'xs'}
                    title={t('general.createReturnRequest')}
                    buttonText={t('general.search')}
                    functionButtonOnClick={listele}
                    sx={{ padding: 0 }}
                >
                    <Grid
                        className="return-list-create-return-modal"
                        container
                        direction="row"
                        spacing={2}
                        sx={{ paddingLeft: 1 }}
                    >
                        <Grid
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            {' '}
                            <SCUILoadingLinear display={loading} />
                        </Grid>
                        <Grid
                            className="return-list-create-return-modal-search-input"
                            sx={{ padding: 0 }}
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <SCUITextFieldWithSelectBox
                                sx={{ width: '400px' }}
                                selectList={[
                                    { value: 1, text: t('general.orderNo') },
                                    { value: 2, text: t('general.shippingNo') },
                                ]}
                                onChangeSelect={(event: any) => {
                                    setDocumentType(event.target.value as number);
                                }}
                                selectValue={documentType}
                                onChangeTextField={(event: any) => {
                                    setSearchedText(event.target.value);
                                }}
                                onClickButton={() => listele()}
                                onKeyPressTextField={(e: any) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        listele();
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                </SCUIGeneralModal>
            )}
        </React.Fragment>
    );
};
